export default {
  studentProgrammes: "student/programmes",
  setupProgrammes: "setup/programmes",
  getRegistrations: "student/programme-registration",
  postRegistration: "student/programme-registration",
  patchRegistration: "student/programme-registration/update",
  registrationDocument: (regNo) => `programme_summary?registrationNo=${regNo}`,
  examCenters: "setup/exam-centers",
  regions: "setup/cities",
  countries: "setup/countries",
  studentUnits: "student/units",
  booking: "exams/booking/book",
  postalCodes: "setup/postal-codes",
  semesters: "setup/semesters",
  programmeStages: "setup/programmeStages",
  studentTypes: "setup/studentTypes",
  examTimetable: "setup/examTimetable",
  RENEWALS: "student/renewals",
  RENEWAL_PROFORMA: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getRenewalProforma?serviceRequestNo=${id}`,
  receipt: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getReceiptReport?receiptNo=${id}`,
};
